export const CERTIFICATE_TANANT_LIST_ADMIN_REQUEST = "CERTIFICATE_TANANT_LIST_ADMIN_REQUEST";
export const CERTIFICATE_TANANT_LIST_ADMIN_SUCCESS = "CERTIFICATE_TANANT_LIST_ADMIN_SUCCESS";
export const CERTIFICATE_TANANT_LIST_ADMIN_FAILURE = "CERTIFICATE_TANANT_LIST_ADMIN_FAILURE";

export const CERTIFICATE_VERIFICATION_REQUEST = "CERTIFICATE_VERIFICATION_REQUEST";
export const CERTIFICATE_VERIFICATION_SUCCESS = "CERTIFICATE_VERIFICATION_SUCCESS";
export const CERTIFICATE_VERIFICATION_FAILURE = "CERTIFICATE_VERIFICATION_FAILURE";

export const CERTIFICATE_THEME_LIST_REQUEST = "CERTIFICATE_THEME_LIST_REQUEST";
export const CERTIFICATE_THEME_LIST_SUCCESS = "CERTIFICATE_THEME_LIST_SUCCESS";
export const CERTIFICATE_THEME_LIST_FAILURE = "CERTIFICATE_THEME_LIST_FAILURE";

export const CERTIFICATE_THEME_CREATE_REQUEST = "CERTIFICATE_THEME_CREATE_REQUEST";
export const CERTIFICATE_THEME_CREATE_SUCCESS = "CERTIFICATE_THEME_CREATE_SUCCESS";
export const CERTIFICATE_THEME_CREATE_FAILURE = "CERTIFICATE_THEME_CREATE_FAILURE";
export const CERTIFICATE_THEME_CREATE_RESET = "CERTIFICATE_THEME_CREATE_RESET";

export const CERTIFICATE_THEME_UPDATE_REQUEST = "CERTIFICATE_THEME_UPDATE_REQUEST";
export const CERTIFICATE_THEME_UPDATE_SUCCESS = "CERTIFICATE_THEME_UPDATE_SUCCESS";
export const CERTIFICATE_THEME_UPDATE_FAILURE = "CERTIFICATE_THEME_UPDATE_FAILURE";
export const CERTIFICATE_THEME_UPDATE_RESET = "CERTIFICATE_THEME_UPDATE_RESET";

export const CERTIFICATE_THEME_DELETE_REQUEST = "CERTIFICATE_THEME_DELETE_REQUEST";
export const CERTIFICATE_THEME_DELETE_SUCCESS = "CERTIFICATE_THEME_DELETE_SUCCESS";
export const CERTIFICATE_THEME_DELETE_FAILURE = "CERTIFICATE_THEME_DELETE_FAILURE";

export const CERTIFICATE_LIST_USER_REQUEST = "CERTIFICATE_LIST_USER_REQUEST";
export const CERTIFICATE_LIST_USER_SUCCESS = "CERTIFICATE_LIST_USER_SUCCESS";
export const CERTIFICATE_LIST_USER_FAILURE = "CERTIFICATE_LIST_USER_FAILURE";
